import React, { useCallback } from "react";
import { Save, X } from "lucide-react";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function SaveRulePopup({ closePopup, confirm, ruleData }) {

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    function getTargetTypeInfoString(elements) {
        if (!elements.length) {
            return ' - '
        }
        return elements.map(el => el.name).join(', ');
    }

    const summaryItems = [
        { label: "Rule Name", value: ruleData.name || " - " },
        { label: "Version", value: ruleData.version || " - " },
        { label: "Severity", value: ruleData.severity || " - " },
        { label: "MSB", value: getTargetTypeInfoString(ruleData.msbList || []) },
        { label: "Device Types", value: getTargetTypeInfoString(ruleData.deviceTypes || []) },
        { label: "Compliances", value: getTargetTypeInfoString(ruleData.compliance || []) },
        { label: "Locations", value: getTargetTypeInfoString(ruleData.locations || []) },
        { label: "Sectors", value: getTargetTypeInfoString(ruleData.sectors || []) },
    ];

    const onSaveClick = () => {
        closePopup();
        confirm();
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-save-rule-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--wide" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <Save size={18} />
                        </div>
                        <div>
                            <h4 id="oct-save-rule-title" className="oct-shared-popup__title">Save Rule</h4>
                            <p className="oct-shared-popup__subtitle">Review the rule details before saving it to the MSB library.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close save rule popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--summary">
                    <div className="oct-shared-popup__summary-grid">
                        {summaryItems.map((item) => (
                            <div className="oct-shared-popup__summary-card" key={item.label}>
                                <span className="oct-shared-popup__summary-label">{item.label}</span>
                                <span className="oct-shared-popup__summary-value">{item.value}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--primary" onClick={onSaveClick}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    )

}

export default SaveRulePopup;
